var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V9.103a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4173CD",
    d: "M185.379 37.55H512v37.272H185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 74.825h512v37.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4173CD",
    d: "M185.379 112.088H512v37.272H185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 149.363h512v37.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4173CD",
    d: "M0 186.637h512v37.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 223.912h512v37.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4173CD",
    d: "M0 261.175h512v37.272H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M63.976 23.642l14.767 68.333 23.107-9.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M63.976 23.642l26.32 63.547-11.553 4.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M121.404 162.289l-14.768-68.333-23.107 9.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M121.404 162.289L95.083 98.742l11.553-4.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M162.013 64.252L93.681 79.019l9.571 23.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M162.013 64.252l-63.547 26.32-4.785-11.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M23.367 121.679l68.332-14.767-9.572-23.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M23.367 121.679l63.546-26.32 4.786 11.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M121.404 23.642L83.529 82.403l23.107 9.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M121.404 23.642L95.083 87.189l-11.554-4.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M63.976 162.289l37.874-58.761-23.107-9.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M63.976 162.289l26.32-63.547 11.554 4.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M162.013 121.679l-58.761-37.874-9.571 23.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M162.013 121.679l-63.547-26.32 4.786-11.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M23.367 64.252l58.76 37.874 9.572-23.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M23.367 64.252l63.546 26.32-4.786 11.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M92.69 17.931L80.184 86.712h25.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M92.69 17.931v68.781H80.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M92.69 168l12.505-68.781H80.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M92.69 168V99.219h12.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M167.724 92.966L98.943 80.46v25.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M167.724 92.966H98.943V80.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M17.655 92.966l68.781 12.505V80.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M17.655 92.966h68.781v12.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M145.747 39.908L88.268 79.701l17.686 17.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M145.747 39.908L97.111 88.544l-8.843-8.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M39.633 146.023l57.478-39.793-17.686-17.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M39.633 146.023l48.635-48.636 8.843 8.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M145.747 146.023l-39.793-57.479-17.686 17.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M145.747 146.023L97.111 97.387l8.843-8.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M39.633 39.908l39.792 57.479 17.686-17.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD5A",
    d: "M39.633 39.908l48.635 48.636-8.843 8.843z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE15A",
    cx: 92.69,
    cy: 92.966,
    r: 25.012
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.2471ee7abb1ca0da05c7aab4a9b8e5cd.svg";
export { ForwardRef as ReactComponent };